export const isPremium = plan => {
  return plan == 'premium' || plan == 'new_premium'
}



// WEBPACK FOOTER //
// client/utils/plans.js